import { render, staticRenderFns } from "./PaxConfigLine.vue?vue&type=template&id=27c5db76"
import script from "./PaxConfigLine.vue?vue&type=script&lang=js"
export * from "./PaxConfigLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports